import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Download = () => {
    const navigate = useNavigate();
    useEffect(() => {
        const ua = navigator.userAgent || navigator.vendor || window.opera;

        const isIOS =
        /iPhone|iPad|iPod/i.test(ua) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1); // iPadOS Safari

        if (isIOS) {
        // Your App Store link
        window.location.href = "https://apps.apple.com/app/invoice-template-snapbill/id6753898367";
        return;
        }

        // Non-iOS devices → go home
        navigate("/", { replace: true });
    }, [navigate]);
    return (
        <div className="flex items-center justify-center h-screen">
            Redirecting…
        </div>
    )
}

export default Download